// Stable source → color mapping for Galaxy Gate visual cues.
const sourceColorMap = {
  twitter: '#1DA1F2',
  x: '#1DA1F2',
  tiktok: '#EE1D52',
  google: '#F4B400',
  direct: '#CCCCCC',
  influencer: '#9C27B0',
  referral: '#9C27B0',
  unknown: '#888888',
};

export default sourceColorMap;
